import { Injectable, inject } from '@angular/core';
import { Observable, of as observableOf } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { SelfDiagnosisModel } from './model';
import { SelfDiagnosisState } from './state';
import * as selectors from './selectors';
import * as actions from './actions';
import { UserFacade } from '../../user/facade';

@Injectable()
export class SelfDiagnosisFacade {
  private store = inject<Store<SelfDiagnosisState>>(Store);
  private userFacade = inject(UserFacade);

  public entities$ = this.store.pipe(select(selectors.allSelector));
  public selected$ = this.store.pipe(select(selectors.selectedSelector));

  constructor() {
    this.getAll();
  }

  public getAll() {
    this.userFacade.selected().subscribe(user => {
      if (user) {
        this.store.dispatch(new actions.GetAllRequest());
      }
    });
  }

  public getById(id: number) {
    this.store.dispatch(new actions.GetByIdRequest(id));
  }

  public update(entity: SelfDiagnosisModel) {
    this.store.dispatch(new actions.UpdateRequest(entity));
  }

  public delete(id: number) {
    this.store.dispatch(new actions.DeleteRequest(id));
  }

  public uploadIcon(entity: SelfDiagnosisModel, file: File) {
    this.store.dispatch(new actions.UploadIconRequest(entity, file));
  }

  public deleteIcon(entity: SelfDiagnosisModel) {
    this.store.dispatch(new actions.DeleteIconRequest(entity));
  }

  public setSelected(entity: SelfDiagnosisModel) {
    this.store.dispatch(new actions.SetSelected(entity));
  }

  public getError(): Observable<any> {
    return this.store.pipe(select(selectors.errorSelector));
  }

  public isLoading(): Observable<boolean> {
    return this.store.pipe(select(selectors.isLoadingSelector));
  }
}
